export interface FunderRecord {
  account: string
  deal_id: string
  deal_name: string
  deal_amount: number
  closed_won_date: string
  company_id: string
  company_name: string
  company_domain: string
  association_label: string
  association_category: string
  association_type_id: number
  potential_funder: boolean
}

export interface CompanyAssociation {
  company_id: string
  company_name: string
  company_domain: string
  association_label: string
  association_category: string
  association_type_id: number
  potential_funder: boolean
}

export interface DealSummary {
  deal_id: string
  deal_name: string
  account: string
  deal_amount: number
  closed_won_date: string
  companies: CompanyAssociation[]
}

export interface AccountGroup {
  account: string
  deals: DealSummary[]
  total_amount: number
  deal_count: number
}

export interface FunderFilter {
  account?: string
  association_label?: string[]
  potential_funder?: boolean | null
  date_range?: {
    start: string
    end: string
  }
  amount_range?: {
    min: number
    max: number
  }
  search?: string
  exclude_no_companies?: boolean
}

export interface FunderStats {
  total_deals: number
  total_amount: number
  potential_funders: number
  accounts: string[]
  top_funders: Array<{
    company_name: string
    deal_count: number
    total_amount: number
  }>
}

export interface AssociationChange {
  id: string
  deal_id: string
  deal_name: string
  company_id: string
  company_name: string
  company_domain: string
  old_association: string
  new_association: string
  timestamp: string
  user: string
}

export interface FunderInfo {
  company_id: string
  company_name: string
  company_domain: string
  deal_count: number
  total_amount: number
  deals: Array<{
    deal_id: string
    deal_name: string
    deal_amount: number
    closed_won_date: string
  }>
}

export interface AccountFunders {
  account: string
  funders: FunderInfo[]
  total_funders: number
  total_amount: number
  total_deals: number
}

export interface CompanyInfo {
  company_id: string
  company_name: string
  company_domain: string
  account: string
  deal_count: number
  total_amount: number
  association_labels: string[]
  deals: Array<{
    deal_id: string
    deal_name: string
    deal_amount: number
    closed_won_date: string
    association_label: string
  }>
}

export interface AllCompaniesData {
  companies: CompanyInfo[]
  total_companies: number
  total_amount: number
  total_deals: number
  accounts: string[]
}

export type AssociationLabel = 'Primary' | 'Funder' | 'Supplier' | 'Unlabeled'

export const ASSOCIATION_OPTIONS: AssociationLabel[] = ['Primary', 'Funder', 'Supplier', 'Unlabeled']